import DischargeInstructionsList from 'components/common/DischargeInstructionsList'
import PendingVisit from 'models/Provider/visits/PendingVisit'

type DischargeInstructionsProps = {
  visit: PendingVisit
  isSuccess?: boolean
}

const DischargeInstructions = ({ visit, isSuccess }: DischargeInstructionsProps) => {
  return (
    <div className="mb-6">
      <p className="typography-caption text-neutral-500">{isSuccess ? 'Guides' : 'Discharge instructions'}</p>
      <div className="flex flex-col mt-1 gap-2">
        <DischargeInstructionsList visit={visit} isSuccess={isSuccess} />
      </div>
    </div>
  )
}

export default DischargeInstructions
